export const authPaths = {
  "forgot-email": "/auth/forgot-password",
  "forgot-password": "/auth/reset-password",
  "forgot-sent": "/auth/forgot-password/sent",
  guest: "/auth/guest",
  "sign-in": "/auth/sign-in",
  "sign-up": "/auth/sign-up",
  "sign-up-verification": "/auth/verify-email",
  "reset-invalid": "/auth/reset-password/invalid",
  "reset-success": "/auth/reset-password/complete",
} as const;
export type AuthView = keyof typeof authPaths;
